import { store } from './store';

export function getCurrentGlobalState() {
    return store().getState();
}

// window.__ecore2.store.getState().global => window.__getStoreGlobalData()
window.__getStoreGlobalData = () => getCurrentGlobalState().global;

// window.__ecore2.store.getState().analytics.pageInfo.pageType => window.__getStoreAnalyticsPageData().pageType
window.__getStoreAnalyticsPageData = () => getCurrentGlobalState().analytics.pageInfo;

// window.__ecore2.store.getState().product.details.code => window.__getStoreProductDetailsData().code
window.__getStoreProductDetailsData = () => getCurrentGlobalState().product.details;

// window.__ecore2.store.getState().cart.data.totalItems => window.__getStoreCartTotalData().totalItems
window.__getStoreCartTotalData = () => {
    const { totalItems } = getCurrentGlobalState().cart.data;
    return { totalItems };
};
